import Button from '@creator/ui/components/Button/ButtonV2';
import Text from '@creator/ui/components/Text/Text';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface LoadMoreButtonProps {
    hasMore: boolean;
    loadStatus: 'loading' | 'success' | 'error' | 'idle';
    onLoadMore: () => void;
}

const LoadMoreButton: FC<LoadMoreButtonProps> = ({ hasMore, loadStatus, onLoadMore }) => {
    const { t } = useTranslation();

    if (!hasMore) return null;

    return (
        <div className="flex justify-center mt-6">
            <Button onClick={onLoadMore} isLoading={loadStatus === 'loading'}>
                <Text>{t('tokenPage.reports.loadMoreButton')}</Text>
            </Button>
        </div>
    );
};

export default LoadMoreButton;
